const billingDetails = [
  {
    billingType: "Basic Billing",
    devices: "Android mobile app",
    numberOfUsers: "Two user",
    extras: "",
  },
  {
    billingType: "Advance Billing",
    devices: "Android and iOS mobile apps, laptop, offline use on laptop",
    numberOfUsers: "Up to 3 userss",
    extras: "",
  },
  {
    billingType: "Enterprise Billing",
    devices: "Android and iOS mobile apps, laptop, offline use on laptop",
    numberOfUsers: "4 or more users",
    extras: "e-Invoicing, eWay Billing, POS System",
  },
];

const businessSize = [
  {
    label: "Less than 40 lakhs",
    value: "40Lakhs",
  },
  {
    label: "40 Lakhs to 1 crore",
    value: "40To1C",
  },
  {
    label: "More than 1 crore",
    value: "morethan1C",
  },
];
const billbookSource = [
  {
    label: "Google or other search engine ",
    value: "Google or other search engine ",
  },
  {
    label: "Ad on Youtube, Instagram, Facebook etc",
    value: "Ad on Youtube, Instagram, Facebook etc",
  },
  {
    label: "Recommended by someone",
    value: "Recommended by someone",
  },
  {
    label: "Blogs or news or other websites",
    value: "Blogs or news or other websites",
  },
  {
    label: "Other",
    value: "Other",
  },
];
const languageList = [
    {
        label: "Tamil ",
        value: "Tamil ",
      },
      {
        label: "English",
        value: "English",
      },
      {
        label: "Malayalam",
        value: "Malayalam",
      },
      {
        label: "Kannada",
        value: "Kannada",
      },
      {
        label: "Telugu",
        value: "Telugu",
      },
      {
        label: "Hindi",
        value: "Hindi",
      },
      {
        label: "Others",
        value: "Others",
      },
];

export { businessSize, billingDetails, languageList, billbookSource };
